export class FileService {
    private static readonly allowedTypesCV = [
        'text/plain',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];

    static pdf({ blob, url, filename }: { blob: Blob; url: string; filename?: string }) {
        URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${filename}.pdf`;
        link.click();
        URL.revokeObjectURL(url);
    }

    static checkCVsize(fileList: FileList, maxMB: number): boolean {
        const file = fileList[0];

        if (file) {
            file.size;
            console.log(file.type);
            return (
                file.size <= maxMB * 1024 * 1024 &&
                FileService.allowedTypesCV.includes(file.type)
            );
        }
        return false;
    }
}
